import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/4888c6cef22b13b79f3c035825dc10479f5392f3.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/f4a4a728f2d9f6a48c6b8e5eab0f62cf770a390c.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/f7946760c40184810c84bb28c9f2e38b625ca4a1.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/atoms/ImageWithFallback/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchField"] */ "/app/src/components/atoms/SearchField/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel3DWrapper"] */ "/app/src/components/molecules/Carousel3D/Carousel3DWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/HeroSection/styles.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/ContentGridSection/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NewEquipmentCarouselClient"] */ "/app/src/components/organisms/NewEquipmentCarousel/NewEquipmentCarouselClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/PartnersGrid/styles.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/EquipmentSectorsGrid/styles.scss");
